<template>
  <div class="container" :class="{'pad-btm': hasBuy}">
    <div class="page-card">
      <div class="card-title">
        <div class="big-title">开放诊断职业：</div>
        <div class="title-wrap">
          <span class="title-item" v-for="item in subjectList" :key="item">{{item}}</span>
        </div>
      </div>
      <div class="card-poup">
        <div class="card-poup-item poup1">你的技术能力<br />到底如何</div>
        <div class="card-poup-item poup2">你距大厂Offer<br />差在哪？</div>
        <div class="card-poup-item poup3">你的核心竞争力<br />是什么？</div>
      </div>
      <div class="card-bottom">
        <div class="header-title-common">
        <div class="title-wrap">
          <p>是时候找一个行业高手替你把把脉！</p>
        </div>
      </div>
      </div>

    </div>
    <div class="page-card-1">
      <div class="header-title">你将收获</div>
      <div class="card-wrap">
        <div class="card-item">
          <span class="item-icon item-icon1"></span>和技术大牛 60min 1v1 的充分交流
        </div>
        <div class="card-item">
          <span class="item-icon item-icon2"></span>一份全面、精准的职业能力评估反馈
        </div>
          <div class="card-item">
          <span class="item-icon item-icon3"></span>来自技术专家的专属提升建议
        </div>
      </div>
      <div class="bottom-btn btn" @click="handleClick('立即体验')">
        立即体验
        <img src="../assets/img/h5/finger.png" alt="手指" class="finger">
      </div>
    </div>
    <div class="page-card-2">
      <div class="header-title">4大能力维度全面评估</div>
      <div class="skill-wrap">
        <div class="skill-item flex" v-for="skill in skillList" :key="skill.id">
          <img class="skill-icon" :src="skill.icon">
          <div class="skill-des">
            <div class="skill-des-title">{{skill.title}}</div>
            <div class="skill-des-detail">
              <span v-for="(detail,deId) in skill.skillDetail" :key="deId">
                【{{detail}}】
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-card-3">
      <div class="header-title">一线大厂技术专家坐镇</div>
      <div class="lable-wrap">
        <div class="lable-wrap-top flex flex-center lable-wrap-list">
          <div class="lable-item">5-10年经验</div>
          <div class="lable-item">资深面试官</div>
          <div class="lable-item">项目经验丰富</div>
        </div>
        <div class="lable-wrap-bottom flex flex-center lable-wrap-list">
          <div class="lable-item">架构师</div>
          <div class="lable-item">技术专家</div>
          <div class="lable-item">技术负责人</div>
        </div>
      </div>
      <div class="sw-box">
        <div class="swiper-container sw-container">
          <div class="swiper-wrapper current-wraps">
            <div class="swiper-slide sw-item"
                v-for="(tutor, index) in tutorList"
                :key="index"
            >
            <div class="sw-img-container">
              <img class="sw-img" :src="tutor"/>
            </div>
            </div>
          </div>
        </div>
      </div>
      <div class="company">
        <img src="https://s21.lgstatic.com/growth/activity/20211231/1640933155932.png?x-oss-process=style/80" alt="">
      </div>
    </div>
    <div class="page-card-4">
      <div class="header-title">服务流程</div>
      <div class="title-des">本服务适合执行层/初级管理层的能力诊断与</div>
      <div class="indicate-wrap">
        <img class="indicate-img" src="../assets/img/h5/indicate_icon_1.png" />
        <img
          class="indicate-img-line"
          src="../assets/img/h5/indicate_line_right.png"
        />
        <img class="indicate-img" src="../assets/img/h5/indicate_icon_2.png" />
        <img
          class="indicate-img-line"
          src="../assets/img/h5/indicate_line_right.png"
        />
        <img class="indicate-img" src="../assets/img/h5/indicate_icon_3.png" />
      </div>
      <div class="indicate-txt">
        <div class="indicate-txt-item">点击报名</div>
        <div class="indicate-txt-item">扫码添加工作人员</div>
        <div class="indicate-txt-item">匹配诊断官<br />预约诊断</div>
      </div>
      <div class="indicate-wrap indicate-wrap-other">
        <img class="indicate-img" src="../assets/img/h5/indicate_icon_5.png" />
        <img
          class="indicate-img-line"
          src="../assets/img/h5/indicate_line_left.png"
        />
        <img class="indicate-img" src="../assets/img/h5/indicate_icon_4.png" />
        <img
          class="indicate-img-pos"
          src="../assets/img/h5/indicate_line_down.png"
        />
      </div>
      <div class="indicate-txt indicate-txt-other">
        <div class="indicate-txt-item">收获诊断反馈<br />+专人解读</div>
        <div class="indicate-txt-item">1v1在线实时<br />语音诊断</div>
      </div>
      <div class="indicate-tips">
        *产品兑换有效期14天，付款后请尽快和工作人员预约
      </div>
    </div>
    <div v-if="showModal" class="modal-container">
      <div class="modal">
        <div class="modal-close" @click="showModal = false"></div>
        <div class="modal-header">
          <img class="modal-header-img" src="../assets/img/h5/succeed_icon.png">
          <span class="modal-header-txt">报名成功</span>
        </div>
        <div class="modal-desc">添加小助手，预约专家服务</div>
        <img class="qrCode" :src="isApp ? qrCodeUrl : qrCodeUserUrl" />
        <div class="modal-btn" @click="openWeapp">{{ isApp ? '立即添加' : '长按图片识别' }}</div>
      </div>
    </div>
    <div class="footer-wrap">
      <div v-if="!hasBuy" class="footer">
        <div class="footer-left">
          <div class="price">
            <span class="symbol">￥</span>1<span class="cut">原价￥699</span>
          </div>
          <div class="price-tips">限量特惠</div>
        </div>
        <div class="footer-right"  @click="handleClick('支付按钮')">
          <span>机会有限，先占先得</span>
          <img class="footer-img" src="../assets/img/h5/footer_icon.png" />
          <div class="right-tips">每位用户限购1次</div>
          <img
            class="img-btns"
            src="https://s21.lgstatic.com/growth/activity/20210831/1630410757988.png"
          />
        </div>
      </div>
      <div v-else class="footer-oth">
        <div class="footer-oth-left" @click="handleShowModal">获取专属能力诊断</div>
        <div class="footer-oth-right" @click="handleClick('¥699 购买')">¥699 购买</div>
      </div>
      <div class="footer-tips">
          付费即表示同意<span class="service" @click="toService">《拉勾增值服务协议》</span>
        </div>
    </div>
    <NewRetainModal
        :visible="retainModalVisible"
        title="真的要拒绝升职加薪的机会吗？"
        cancelBtnText="残忍拒绝"
        confirmBtnText="我再想想"
        :pageId="page_id"
        @onCancle="cancle"
        @onConfirm="removeHash"
      />
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
import { purchasedCourse,postIsBuyCourse } from "../../../service/api";
import { getEduAppVersion, isBiggerThanSpecifiedVersion } from '../../../uitl/getVersion';
import * as Cookies from 'js-cookie';
import LgPay from 'lg-pay';
const lgPay = new LgPay();
import NewRetainModal from '../../../components/NewRetainModal/index.vue'
export default {
  name: "InterviewCardH5",
  data() {
    return {
      tutorList: [
        'https://s21.lgstatic.com/growth/activity/20211231/1640932519648.png?x-oss-process=style/80',
        'https://s20.lgstatic.com/growth/activity/20211231/1640932550203.png?x-oss-process=style/80',
        'https://s21.lgstatic.com/growth/activity/20211231/1640932560657.png?x-oss-process=style/80',
        'https://s21.lgstatic.com/growth/activity/20211231/1640932570080.png?x-oss-process=style/80'
      ],
      userList: [
        {
          name: "吴**",
          img: "https://s21.lgstatic.com/growth/activity/11-11/1604566029247.jpg",
          workYears: "工作5年",
          post: "Java高级开发工程师",
          mark: "不愧是大厂的技术大佬！真是一针见血，毫不留情地帮我找到了当前的问题，也让我清楚了自己努力的方向，告诉我接下来可以怎么做，我计划一年之内搞定大厂！",
        },
        {
          name: "花螺",
          img: "https://s21.lgstatic.com/growth/activity/11-11/1604566040664.jpg",
          workYears: "工作2年",
          post: "数据专员",
          mark: "诊断官的背景也太牛了哈哈，感觉他一眼就能看穿我。平时工作一直不知道自己优势在哪。这次有牛人给我建议，一下子让我有了信心和方向，太太太值得了！",
        },
        {
          name: "Zenn",
          img: "https://s21.lgstatic.com/growth/activity/11-11/1604566059669.jpg",
          workYears: "工作3年",
          post: "大数据开发工程师",
          mark: "特别感谢我的诊断老师，对我的岗位技能做了剖析，让我知道自己现在的水平对应名企的位置，给了我很大的信心，我终于鼓起勇气跟公司提了涨薪！",
        },
      ],
      showModal: false,
      hasBuy: true,
      isAndroid: navigator.userAgent.indexOf('Android') !== -1,
      qrCodeUserUrl: 'https://s20.lgstatic.com/growth/activity/20211215/1639548810152.png?x-oss-process=style/80',
      qrCodeUrl: 'https://s21.lgstatic.com/growth/activity/20211215/1639560244765.png?x-oss-process=style/80',
      subjectList:['大数据','前端','测试','Java'],
      skillList:[
        {
          id:1,
          icon:require("../assets/img/h5/skill-1.png"),
          title:"岗位技能基础",
          skillDetail:['核心技术栈','深度','思维']
        },
        {
          id:2,
          icon:require("../assets/img/h5/skill-2.png"),
          title:"项目基础",
          skillDetail:['项目流程规范','项目雷区','任务开发协同步']
        },
        {
          id:3,
          icon:require("../assets/img/h5/skill-3.png"),
          title:"需求落地/业务思维",
          skillDetail:['业务主导','突发问题处理','需求拆解']
        },
        {
          id:4,
          icon:require("../assets/img/h5/skill-4.png"),
          title:"软技能",
          skillDetail:['跨部门沟通','团队协作','向上管理','职业发展瓶颈']
        }
      ],
      page_id:'n1tfd',
      retainModalVisible: false,
    };
  },
  components: {
    NewRetainModal,
  },
  created() {
    // App支付成功显示弹窗
    window.lgBridge && window.lgBridge.response('nativePurchaseCallback', function (data, response, ext) {
      window.location.href = `${location.origin}${location.pathname}?hasBuy=1`
    });
    if (location.href.includes('hasBuy') && location.hash != '#refreshed') {
      location.hash = 'refreshed'
      this.showModal = true;
    }
  },
  mounted() {
    this.eduPlatTrack('WebView', {
        page_id: this.page_id
    });
    this.renderSwipers1();
    // if (Cookies.get('gate_login_token') || Cookies.get('edu_gate_login_token') || this.isApp) {
    //   this.purchasedCourse();
    // }
    // ios
    window.appBeforeGoBack = ()=> {
      this.watchHashChange();
      return 0
    }
    // android
    if (isBiggerThanSpecifiedVersion(getEduAppVersion(), '2.3.4')) {
        window.appBeforeUnLoaded = ()=> {
           this.watchHashChange();
        }
    }
  },
  methods: {
    watchHashChange() {
        postIsBuyCourse().then(res => {
            if (res.state == 1) {
              let modalCount = localStorage.getItem('modalCount_'+this.page_id)
                if (res.content || (modalCount  && parseInt(modalCount) >= 3)) {
                   this.retainModalVisible = false
                    window.lgBridge && window.lgBridge.request('close', {}, (res) => {});
                } else {
                    this.retainModalVisible = true;
                }
            }
        })
    },
    removeHash() {
        this.eduPlatTrack('WebButtonClick', {
            'page_id': this.page_id,
            'button_name': '模拟面试卡-我再想想'
        });
        this.retainModalVisible = false
    },
    cancle(){
        this.eduPlatTrack('WebButtonClick', {
          'page_id': this.page_id,
          'button_name': "模拟面试卡-残忍拒绝"
        });
       this.retainModalVisible = false;
       window.lgBridge && window.lgBridge.request('close', {}, (res) => {});
    },
    purchasedCourse() {
      purchasedCourse().then(res => {
        if (res.state == 1) this.hasBuy = res.content || false;
      })
    },
    renderSwipers1() {
      let option = {
        effect: "coverflow",
        loop: true,
        speed: 1500,
        autoplayDisableOnInteraction: false,
        autoplay: 3000,
        slidesPerView: "auto",
        centeredSlides: true,
        coverflow: {
            rotate: 0,
            stretch: 196, // slide左右距离
            depth: 80, // slide前后距离
            modifier: 1, //
            slideShadows: true // 滑块遮罩层
        },
      };
      this.$nextTick(() => {
        const swiper = new Swiper(".sw-container", option);
      });
    },
    handleClick(buttonName) {
        if (!Cookies.get('gate_login_token') && !Cookies.get('edu_gate_login_token')) {
          return window.open('/frontLogin.do', '_self');
        }
        this.eduPlatTrack('WebButtonClick', {
          'page_id': this.page_id,
          'button_name': buttonName
        });
        const expandInfo = `${location.origin}${location.pathname}?hasBuy=1`;
        const params = this.hasBuy ? {
          payLagouCoinNum: 699,
          sellGoodsPriceId: 104412,
          expandInfo
          } : {
            payLagouCoinNum: 1,
            sellGoodsPriceId: 104413,
            expandInfo
          }
        lgPay.submitV2(params, {
          payScenesKey: 'kai_wu',
          courseId: 1154
        }).then(() => {

        }).catch(() => {
        });
    },
    // 设置url
    setHashUrl(url = '') {
        let hashString = '';
        let finalString = url;
        if (url.indexOf('#') > -1) {
            const hashArr = url.split('#');
            hashString = `#${hashArr[1]}`;
            finalString = hashArr[0] || '';
        }
        return { finalString, hashString };
    },
    toService(){
      this.eduPlatTrack('WebButtonClick', {
            'page_id': this.page_id,
            'button_name': '增值服务协议按钮'
      });
      setTimeout(() => {
        this.goHref("https://activity.lagou.com/app/business/service-agreement.html")
      }, 200);
    },
    handleShowModal() {
      this.eduPlatTrack('WebButtonClick', {
          'page_id': this.page_id,
          'button_name': "获取专属能力诊断"
        });
      if (this.isApp) {
        return this.openWeapp();
      }
      this.showModal = true;
    },
    openWeapp() {
      if (!this.isApp) {
        return;
      }
      this.showModal = false;
      window.lgBridge && window.lgBridge.request('check_install', {
        'data': {
            'app_names': ['wechat']
        }
      }, (res) => {
        if (res.data && res.data.data) {
          let { wechat } = res.data.data;
          if (wechat === 0) {
            /**
             * miniProgramType
             *    IOS: 1 小程序正式版  2 开发版  3 体验版
             *    安卓: 0 小程序正式版  1 开发版  2 体验版
             */
            const userName = 'gh_5bc6c955d1db';
            const path = `/pages/card/index.html`;
            const miniProgramType = this.isAndroid ? 0 : 1;
            const locationPath = encodeURIComponent(path);
            if (this.isEduApp) {
              const version = isBiggerThanSpecifiedVersion(getEduAppVersion(), '2.3.2');
              const bridgeTitle = this.isAndroid ? version ? 'lgedu' : 'lgeduapp' : 'lgedu';
              const bridgeUrl = `${bridgeTitle}://lgedu.com/miniProgram?userName=${userName}&path=${locationPath}&miniProgramType=${miniProgramType}`;
              window.location = bridgeUrl;
            } else if (this.isLgApp) {
              const lgBridgeTitle = this.isAndroid ? 'lagouapp' : 'lagou';
              const lgPath = this.isAndroid ? path : locationPath;
              const lgBridgeUrl = `${lgBridgeTitle}://lagou.com/miniProgram?userName=${userName}&path=${lgPath}&miniProgramType=${miniProgramType}`;
              window.location = lgBridgeUrl;
            }
          } else {
            this.$message.warning('未安装微信');
          }
        }
      });
    }
  },
};
</script>
<style lang='less' scoped>
.container {
  position: relative;
  width: 100%;
  min-height: 910px;
  background: url("https://s21.lgstatic.com/growth/activity/20211230/1640847042259.png") no-repeat top #e0efff;
  background-size: 100% 890px;
  overflow: hidden;
  padding-bottom: 259px;
  &.pad-btm {
    padding-bottom: 213px;
  }
  .header-title-common {
    width: 100%;
    padding: 60px 0 10px 0;
    // height: 68px;
    // line-height: 68px;
    text-align: center;
    color: #2C5BCD;
    font-size: 36px;
    font-weight: 600;
    background: url("../assets/img/h5/header_title_bg.png") no-repeat center;
    background-size: 100% 68px;
    .title-wrap{
      top: -28px;
      position: relative;
      .sub-title{
        font-size: 24px;
      }
    }
  }
  .header-title{
    background: url("../assets/img/h5/title-bg.png") no-repeat center;
    background-size: 100% 100%;
    position: absolute;
    top: -50px;
    left: 50%;
    transform: translate(-50%);
    font-size: 36px;
    text-align: center;
    width: 516px;
    height: 67px;
    line-height: 60px;
    color: #fff;

  }
}
.bottom-btn {
  position: absolute;
  left: 50%;
  bottom: -47px;
  width: 368px;
  height: 94px;
  transform: translateX(-50%);
  color: #fff;
  text-align: center;
  line-height: 94px;
  display: flex;
  font-size: 34px;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  &.btn {
    background: url("../assets/img/h5/bottom_btn.png") no-repeat center;
    background-size: 368px 94px;
  }
  .finger{
    width: 37px;
    height: 49px;
    display: inline-block;
  }
}
.page-card {
  position: relative;
  width: 722px;
  height: 410px;
  margin: 0 auto;
  background: url("https://s21.lgstatic.com/growth/activity/20211231/1640918229039.png") no-repeat center;
  background-size: 100% 100%;
  border-radius: 7px;
  margin-top: 500px;
  box-sizing: border-box;
  overflow: hidden;
  .card-title {
    width: 100%;
    height: 88px;
    font-size: 36px;
    color: #2C5BCD;
    padding: 11px 13px;
    box-sizing: border-box;
    .big-title{
      font-size: 24px;
      font-weight: 600;
    }
    .title-wrap{
      height: 34px;
      line-height: 34px;
    }
    .title-item {
      position: relative;
      height: 34px;
      line-height: 34px;
      text-align: center;
      display: inline-block;
      padding: 0 12px;
      border-radius: 10px;
      margin-right: 8px;
      font-size: 21px;
      font-weight: 500;
      transform: scale(0.9);
      border: 1px solid #2C5BCD;

    }
  }
  .card-poup {
    display: flex;
    width: 100%;
    margin-top: 32px;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 20px;
    box-sizing: border-box;
    .card-poup-item {
      flex-shrink: 0;
      width: 215px;
      height: 122px;
      margin-bottom: 13px;
      padding-top: 30px;
      box-sizing: border-box;
      font-size: 28px;
      color: #2c5bcd;
      font-weight: 600;
      line-height: 42px;
      font-family: PingFangSC-Medium, PingFang SC;
      text-align: center;
      &.poup1 {
        background: url("../assets/img/h5/poup_bg_1.png") no-repeat center;
        background-size: 100% 100%;
      }
      &.poup2 {
        background: url("../assets/img/h5/poup_bg_2.png") no-repeat center;
        background-size: 100% 100%;
      }
      &.poup3 {
        background: url("../assets/img/h5/poup_bg_3.png") no-repeat center;
        background-size: 100% 100%;
      }
    }
  }
  .card-bottom{
    padding: 0 20px;
  }
}
.page-card-1 {
  position: relative;
  width: 722px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 7px;
  margin-top: 118px;
  padding: 68px 80px;
  box-sizing: border-box;
  .card-wrap{
    .card-item{
      font-size: 30px;
      color: #49598B;
      margin-bottom: 22px;
      display: flex;
      align-items: center;
      .item-icon{
        width: 37px;
        height: 37px;
        display: inline-block;
        margin-right: 10px;
        &1{
          background: url("../assets/img/h5/item-icon1.png") no-repeat center;
          background-size: 100% 100%;
        }
        &2{
          background: url("../assets/img/h5/item-icon2.png") no-repeat center;
          background-size: 100% 100%;
        }
        &3{
          background: url("../assets/img/h5/item-icon3.png") no-repeat center;
          background-size: 100% 100%;
        }
      }
    }
  }
}
.page-card-2{
  width: 722px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 7px;
  margin-top: 161px;
  padding: 69px 0 20px 0;
  box-sizing: border-box;
  position: relative;
  .skill-wrap{
    .skill-des{
      font-size: 28px;
      color: #0F286D;
      padding-left: 17px;
      box-sizing: border-box;
      &-detail{
        color:#676767;
        font-size: 24px;
        span{
          font-size: 24px;
          margin-right: -15px;
           &:nth-child(1){
            margin-left: -14px;
          }
          display: inline-block;
        }
      }
      &-title{
        font-weight: 500;
      }
    }
    .skill-icon{
      width: 80px;
      height: 96px;
    }
    .skill-item{
      background-color: #EBF2FF;
      margin-bottom: 18px;
      align-items: center;
      &:nth-child(1){
        width: 451px;
      }
      &:nth-child(2){
        width: 638px;
      }
      &:nth-child(3){
        width: 674px;
      }
      &:nth-child(4){
        width: 708px;
      }
    }
  }
}
.page-card-3{
  width: 722px;
  margin: 0 auto;
  margin-top: 161px;
  padding: 69px 40px 20px 40px;
  background-color: #fff;
  position: relative;
  box-sizing: border-box;
  border-radius: 7px;
  .lable-wrap{
    color: #3257BC;
    font-size: 28px;
    align-content: center;
    justify-content: center;
    font-weight: 500;
    &-top{
      .lable-item{
        padding: 0 18px;
        &:not(first-child){
          margin-left:11px;
        }
      }
    }
    &-bottom{
      margin-top: 13px;
      .lable-item{
        padding: 0 30px;
        &:not(first-child){
          margin-left:11px;
        }
      }
    }
  }
  .lable-item{
    border: 1px solid #3257BC;
    height: 53px;
    line-height: 53px;
    border-radius: 14px;
  }
  .sw-box {
    width: 100%;
    height: 320px;
    margin: 44px 0 26px;
    /deep/ .sw-container {
      width: 100%;
      height: 320px;
    }
    /deep/ .swiper-slide-shadow-left, /deep/ .swiper-slide-shadow-right {
        background: rgba(198, 206, 238, 0.23);
    }
    .sw-item {
      width: 521px !important;
      height: 320px;
      background-color: #fff;
      box-shadow: 0px 0px 3px 0px rgba(198, 206, 238, 0.65);
      border-radius: 4px;
      overflow: hidden;
      .sw-img{
        width: 521px;
        height: 320px;
        &-container{
          width: 521px;
          height: 320px;
          border-radius: 8px;
          box-shadow: 0px 1px 4px 0px rgba(219, 227, 255, 0.47);
          background:linear-gradient(270deg, #FFA74D 0%, #F17000 100%);
          overflow: hidden;
        }
      }
    }
  }
  .company{
    margin-top: 52px;
    img{
      width: 648px;
      height: 273px;
    }
  }
}
.page-card-4 {
  width: 722px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 7px;
  margin-top: 61px;
  box-sizing: border-box;
  position: relative;
  margin-top: 119px;
  padding-bottom: 47px;
  .title-des{
    padding-top: 44px;
    color: #0F286D;
    font-size: 30px;
    text-align: center;
  }
  .indicate-wrap {
    display: flex;
    align-items: center;
    padding: 0 73px 0 78px;
    margin-top: 77px;
    box-sizing: border-box;
    justify-content: space-between;
    &.indicate-wrap-other {
      position: relative;
      padding: 0 197px 0 190px;
      margin-top: 53px;
      .indicate-img-pos {
        position: absolute;
        top: -45px;
        right: 132px;
        width: 58px;
        height: 58px;
      }
    }
    .indicate-img {
      width: 104px;
      height: 104px;
    }
    .indicate-img-line {
      width: 78px;
      height: 24px;
    }
  }
  .indicate-txt {
    display: flex;
    margin-top: 5px;
    padding: 0 54px 0 74px;
    box-sizing: border-box;
    justify-content: space-between;
    font-size: 28px;
    line-height: 40px;
    font-weight: bold;
    color: #1f4ccb;
    &.indicate-txt-other {
      padding: 0 174px 0 157px;
    }
    .indicate-txt-item {
      text-align: center;
    }
  }
  .indicate-tips {
    font-size: 20px;
    line-height: 28px;
    color: rgba(102, 102, 102, 0.62);
    text-align: center;
    margin-top: 52px;
  }
}
.modal-container {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  .modal {
    position: absolute;
    top: 40%;
    left: 50%;
    width: 600px;
    background-color: #fff;
    border-radius: 8px;
    transform: translate(-50%, -50%);
    padding: 60px;
    box-sizing: border-box;
    .modal-header {
      display: flex;
      width: 180px;
      height: 40px;
      line-height: 40px;
      margin: 0 auto;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #333333;
      justify-content: space-between;
      align-items: center;
      .modal-header-img {
        width: 40px;
        height: 40px;
      }
    }
    .modal-desc {
      height: 40px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #666666;
      line-height: 40px;
      text-align: center;
      margin-top: 23px;
    }
    .qrCode {
      display: block;
      width: 350px;
      height: 350px;
      margin: 49px auto 0;
    }
    .modal-btn {
      height: 88px;
      line-height: 88px;
      background: #00B38A;
      border-radius: 4px;
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #FFFFFF;
      text-align: center;
      margin-top: 42px;
    }
    .modal-close {
      width: 60px;
      height: 60px;
      position: absolute;
      left: 50%;
      bottom: -130px;
      border-radius: 50%;
      z-index: 10000;
      background: url("../assets/img/h5/icon_delect@2x.png") no-repeat center;
      background-size: 100%;
      transform: translateX(-50%);
    }
  }
}
.footer-wrap{
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  height: 140px;
  padding-bottom: 83px;
  background-color: #fff;
  width: 100%;
  .footer-tips{
    width: 100%;
    font-size: 24px;
    text-align: center;
    color: #666666;
    margin-top: 16px;
  }
  .service{
    color: #0174DA;
  }
}
.footer {
  display: flex;
  flex: 1;
  width: 100%;
  padding: 0 52px;
  height: 100%;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  .footer-left {
    height: 186px;
    line-height: 156px;
    .price {
      margin-top: 4px;
      font-size: 68px;
      color: #ff5151;
      .symbol {
        font-size: 46px;
      }
      .cut {
        font-size: 30px;
        text-decoration: line-through;
      }
    }
    .price-tips {
      font-size: 41px;
      color: #666;
      height: 30px;
      line-height: 41px;
      text-indent: 8px;
      margin-top: -50px;
    }
  }
  .footer-right {
    position: relative;
    display: flex;
    width: 385px;
    height: 80px;
    line-height: 80px;
    background: linear-gradient(180deg, #ffa351 0%, #ff4000 100%);
    border-radius: 6px;
    font-size: 28px;
    font-weight: bold;
    color: #fff;
    align-items: center;
    text-align: center;
    padding-left: 51px;
    box-sizing: border-box;
    .footer-img {
      width: 12px;
      height: 30px;
      margin-left: 12px;
    }
    .right-tips {
      position: absolute;
      top: -64px;
      right: 54px;
      height: 42px;
      line-height: 42px;
      background-color: #ff5b5b;
      padding: 0 8px;
      border-radius: 4px;
      font-weight: normal;
      font-size: 22px;
      &::after {
        position: absolute;
        bottom: -12px;
        right: 10px;
        display: inline-block;
        content: "";
        border-top: 6px solid #ff5b5b;
        border-right: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-left: 6px solid #ff5b5b;
        z-index: -1;
      }
    }
    .img-btns {
      position: absolute;
      top: -10px;
      left: 0px;
      animation: left 1.5s infinite linear;
      width: 180px;
      height: 100px;
    }
    @keyframes left {
      0% {
        left: -10%;
      }
      50% {
        left: 100%;
      }
      100% {
        left: 200%;
      }
    }
  }
}
.swiper-content {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  padding: 50px 0;

  .show-swiper {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    .swiper-slide {
      width: 500px;
      // 表示所有属性都有动作效果，过度时间为0.4s，以慢速开始和结束的过渡效果
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

      .swiper-item {
        width: 100%;
        height: 500px;
        background: rgb(140, 172, 134);
        border-radius: 6px;
        color: orangered;
        font-size: 24px;
        line-height: 1.5;
        border: 1px solid orangered;
      }
    }
  }
}
.footer-oth {
  display: flex;
  flex: 1;
  width: 100%;
  height: 110px;
  padding: 14px 40px;
  box-sizing: border-box;
  background-color: #fff;
  justify-content: space-between;
  .footer-oth-left {
    width: 420px;
    height: 82px;
    line-height: 82px;
    background: #F2FBF9;
    border-radius: 4px;
    border: 1px solid #00B38A;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #FF7536;
    text-align: center;
    box-sizing: border-box;
    background: #FFFFFF;
    border-radius: 5px;
    border: 1px solid #FFA182;
  }
  .footer-oth-right {
    width: 230px;
    height: 87px;
    line-height: 82px;
    // background: #00B38A;
    background: linear-gradient(180deg, #FFA351 0%, #FF4000 100%);
    border-radius: 4px;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
  }
}
@supports (padding-bottom: constant(safe-area-inset-bottom)) or (padding-bottom: env(safe-area-inset-bottom)) {
  .footer-tips{
    padding-bottom:constant(safe-area-inset-bottom);
    padding-bottom:env(safe-area-inset-bottom);
  }
}
</style>
